module.exports = __webpack_public_path__ + "static/media/Aplausos.cdbbbd13.mp3";